import { HOST_NAME_COCKPIT, HOST_NAME_COCKPIT_ITALY, HOST_NAME_CONTROL } from "./constants";

export const isHostControl = (): boolean => window.location.host.startsWith(HOST_NAME_CONTROL);
export const isHostCockpitItaly = (): boolean =>
    window.location.host.startsWith(HOST_NAME_COCKPIT_ITALY) ||
    (window.location.host.startsWith(HOST_NAME_COCKPIT) && window.location.host.endsWith(".it"));
